// Description: Endpoint to delete one template
// Updated: 08/09/2025
// Author: Simon Franklin

import { getTokenData } from "../../../shared/utils/utils";

export async function TemplateDelete(templateId) {
    try {

        const { token, client_id } = await getTokenData();

        if (!token) throw new Error('Token de autenticação não encontrado');

        if (!client_id) throw new Error('ID do cliente não encontrado');

        const response = await fetch(
            `${process.env.REACT_APP_BACKEND_AWS_URL}/templates/delete`,  
            {
                method: "DELETE",
                body: JSON.stringify(templateId),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    'Client_ID': `${client_id}`
                },
            }
        );

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Erro ao buscar dados da API:', error);
    }
}